import React from 'react'
import {
  Table,
  Input,
} from 'semantic-ui-react'
import { NoData } from '../../components/table/no-data'
import * as api from '../../api'

export default class SiteTableProductionparametersRow extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      utility: 'Gas',
      loadingread: true,
      address: '',
      ref: '',
      propertyname: '',
      lastreading: '',
      lastreadtype: '',
      datelastread: '',
      description: '',
      metersCount: {},
      completenessData: [],
      data: [
        {
          id: props.data.parameter + props.data.value + props.data.siteKey,
          parameter: props.data.parameter,
          value: props.data.value,
          siteKey: props.data.siteKey,
        },
      ],
      editId: null,
      rowData: {
        parameter: '',
        value: '',
        siteKey: '',
      },
    }
  }
 
  handleInput(event) {
    this.setState({
      serialnumber: event.target.value,
    })
  }
 
 getMeterRead = (customerId, meterSiteKey) => { }
  handleInputValue = (event) => {
    this.setState({ testval: event.target.value })
  }

  
  handleEditClick = (event, details) => {
  
    this.setState({ editId: details.id })

    const rowValues = {
      parameter: details.parameter,
      value: details.value,
      siteKey: details.siteKey,
    }
    this.setState({ rowData: rowValues })

  }
  
  handleRowEditChange = (event) => {

    const fieldName = event.target.getAttribute('name')
    const fieldValue = event.target.value
    const newRowData = { ...this.state.rowData }
    newRowData[fieldName] = fieldValue

    this.setState({ rowData: newRowData })
  }

  handleEditedRowSubmit = (event) => {
    event.preventDefault()
    const editedRowDetails = {
      parameter: this.state.rowData.parameter,
      value: this.state.rowData.value,
      siteKey: this.state.rowData.siteKey,
    }
    //Mutating the state(origainal/tableData array of objects)

    const newData = [...this.state.data]

    const index = this.state.data.findIndex(
      (detail) => detail.id === this.state.editId,
    )

    newData[index] = editedRowDetails

    this.setState({ data: newData })

    this.setState({ editId: null })

    
    const formData = new FormData();

    formData.append("parameter", editedRowDetails.parameter);
    formData.append("siteKey",editedRowDetails.siteKey);
    if(editedRowDetails.value===null)
    {
        editedRowDetails.value=' ';
    }

    formData.append("value", editedRowDetails.value);

    api.ProductionParameter_Update(formData)
  }

  handleCancelClick = (event) => {
    this.setState({ editId: null })
  }

  render() {
   
    return (
      <>
        {this.state.data.map((details) => (
          <>
            {this.state.editId === details.id ? (
              <EditableRow
                rowData={this.state.rowData}
                handleRowEditChange={this.handleRowEditChange}
                handleCancelClick={this.handleCancelClick}
                handleEditedRowSubmit={this.handleEditedRowSubmit}
              />
            ) : (
              <ReadOnlyRow
                details={details}
                handleEditClick={this.handleEditClick}
              />
            )}
          </>
        ))}
      </>
    )
  }
}
function ReadOnlyRow({ details, handleEditClick }) {

  return (
    <Table.Row key={details.id}>
      <Table.Cell>{details.parameter || <NoData />} </Table.Cell>
      <Table.Cell className="wordbreaktd">{details.value || <NoData />}</Table.Cell>
      <Table.Cell>{details.siteKey || <NoData />}</Table.Cell>
      <Table.Cell textAlign="center">
        <i onClick={(event) => {
          handleEditClick(event, details)
        }} className="pencil alternate icon cursorpointer"></i>
      </Table.Cell>
    </Table.Row>
  )
}

function EditableRow({
  rowData,
  handleRowEditChange,
  handleCancelClick,
  handleEditedRowSubmit,
}) {
  return (
    <Table.Row>
      <Table.Cell>{rowData.parameter}</Table.Cell>
      <Table.Cell>
        <Input
          type="text"
          name="value"
          value={rowData.value}
          placeholder="Enter your value "
          onChange={handleRowEditChange}
        />
      </Table.Cell>
      <Table.Cell>{rowData.siteKey}</Table.Cell>
      <Table.Cell textAlign="center">
        <div>
          <i className="save icon cursorpointer" onClick={handleEditedRowSubmit}></i>
          <i className="cancel icon cursorpointer" onClick={handleCancelClick}></i>
        </div>
      </Table.Cell>
    </Table.Row>
  )
}
